module.exports = __webpack_public_path__ + "static/close-icon-c63e2c3e371a54236d4bf9be7490efd1.png";